import request from '@/util/server.js'

export const settled = 'https://shop.xinsiluzx.com/settled-merchant/#/' // 商家入驻地址
// export const settled = 'http://36.137.28.80:90/settled-merchant/#/' // 商家入驻地址
// export const settled = 'http://114.117.214.20:90/settled-merchant/#/' // 商家入驻地址

// 获取首页导航栏分类
export function getCategory () {
  return request({
    url: '/classify/getFirstClassify',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/nav.js